import { LINKS } from "../../config/links";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#060f2a]/90 backdrop-blur-sm"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 pt-20 pb-12">
        {/* Giant wordmark */}
        <div className="reveal">
          <div className="flex items-baseline gap-4">
            <span className="h-2 w-2 rounded-full bg-amber-500 translate-y-[-0.8em]" aria-hidden />
            <h3
              data-testid="footer-wordmark"
              className="font-display font-light text-white tracking-[0.04em] text-[84px] sm:text-[140px] lg:text-[200px] leading-none"
            >
              ZIVAE
            </h3>
          </div>
          <div className="mt-4 flex items-center gap-4">
            <span className="h-[1px] w-16 bg-amber-500/70" />
            <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
              Marketing
            </span>
          </div>
        </div>

        {/* Row */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-10 pt-12 border-t border-white/5">
          <div className="md:col-span-5">
            <p className="font-display text-2xl text-white leading-tight max-w-sm">
              Follow-up systems that turn advisor leads into attended,
              closed-revenue appointments.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-sans-body uppercase text-[10px] tracking-[0.3em] text-slate-500 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><a href="#problem" className="hover:text-amber-400 transition-colors">The Problem</a></li>
              <li><a href="#proof" className="hover:text-amber-400 transition-colors">The Proof</a></li>
              <li><a href="#solution" className="hover:text-amber-400 transition-colors">What You Get</a></li>
              <li><a href="#advisor-packages" className="hover:text-amber-400 transition-colors">Pricing</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-sans-body uppercase text-[10px] tracking-[0.3em] text-slate-500 mb-4">
              Get Started
            </div>
            <a
              href={LINKS.calendar}
              data-testid="footer-cta-book"
              className="inline-flex items-center gap-3 bg-amber-600 hover:bg-amber-500 text-slate-950 font-semibold px-6 py-3 text-[12px] uppercase tracking-[0.2em] transition-colors"
            >
              Book Strategy Call
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </a>
            <p className="mt-5 text-xs text-slate-500 leading-relaxed max-w-xs">
              Built for financial advisors who are done chasing cold leads
              and want a system that does it for them.
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
          <span>© {year} Zivae Marketing. All rights reserved.</span>
          <span className="uppercase tracking-[0.24em]">Advisor Growth Systems</span>
        </div>
      </div>
    </footer>
  );
}
